import { Injectable, Inject, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import * as XLSX from "xlsx";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { FormGroup, FormControl } from '@angular/forms';
import { TokenService } from '../service/token.service';
class MenuInfo {
  Id: number;
  MenuName: string;
  MenuURL: string;
  ParentId: string;
  Style: string;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  @Output() login_success = new EventEmitter<boolean>();
  baseurl: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }
  // Upload file service
  async uploadFile(filesToUpload: File[], PathFile: string) {
    if (filesToUpload != undefined && filesToUpload.length > 0) {
      const formData = new FormData();
      formData.append("pathfile", PathFile);
      Array.from(filesToUpload).map(async (file, index) => {
        var tragetfile = file;
        var filename = tragetfile.name;
        formData.append('file' + index, tragetfile, filename);
      });

      return await this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .toPromise();

    } else {
      return false;
    }

  }

  // load lookup
  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  // Export Excel service
   getFileName = (name: string) => {
    let timeSpan = new Date().toISOString();
    let sheetName = name || "ExportResult";
    let fileName = `${sheetName}-${timeSpan}`;
    return {
      sheetName,
      fileName
    };
  };

   exportTableToExcel(tableId: string, name?: string) {
    let { sheetName, fileName } = this.getFileName(name);
    let targetTableElm = document.getElementById(tableId);
    let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{
      sheet: sheetName
    });
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

   exportArrayToExcel(arr: any[], name?: string) {
    let { sheetName, fileName } = this.getFileName(name);

    var wb = XLSX.utils.book_new();
     var ws = XLSX.utils.json_to_sheet(arr);
    
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
     XLSX.writeFile(wb, `${fileName}.xlsx`);
    
  }


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

  //Function convert date with time
  GetDateWithtime(Datevalue: string = null) {
    var date = null;

    if (Datevalue != null && Datevalue != '') {
      date = new Date(Datevalue);
    } else {
      date = new Date();
    }
    var month = '' + (date.getMonth() + 1),
      day = '' + date.getDate(),
      year = date.getFullYear(),
      Hours = date.getHours(),
      Minutes = date.getMinutes();

    var displayhours = '';
    var displayMinutes = '';

    if (month.length < 2)
      month = '0' + month;

    if (day.length < 2)
      day = '0' + day;

    if (Hours.toString().length < 2) {
      displayhours = '0' + Hours;
    } else {
      displayhours = Hours.toString();
    }

    if (Minutes.toString().length < 2) {
      displayMinutes = '0' + Minutes;
    } else {
      displayMinutes = Minutes.toString();
    }
    if (day.length < 2)
      day = '0' + day;

    var Datenow = '';

    Datenow = day + "/" + month + "/" + year + " " + displayhours + ":" + displayMinutes;


    return Datenow;

  }


  // Function convert date format input date
  formatDate(date) {
    if (date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    } else {
      return null
    }

  }

  formatTime(date) {
    if (date) {
      let data:any = new Date(date)
      let hrs: any = data.getHours()
      let mins: any = data.getMinutes()
      if (hrs <= 9)
        hrs = '0' + hrs
      if (mins < 10)
        mins = '0' + mins
      const postTime = hrs + ':' + mins
      return postTime
    } else {
      return null
    }

  }

  //Function convert date format join /
  formatDateExcel(date) {
    if (date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [day, month, year].join('/');
    } else {
      return null
    }

  }


  validateAllFormFields(formGroup: FormGroup) {
     Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  // Function set Form control to Touched
  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


  // convert byte to size file
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  // get type file
  getExtension(filename) {
    var parts = filename.split('.');
    return parts[parts.length - 1];
  }

  //Check page access rights

  async CheckPagingAccessRights()
  {
    //var auth_token = await this.TokenService.RefreshToken();
    //if (!!auth_token)
    //{
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
          //,'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectData = {};
      objectData['RoleCode'] = localStorage.getItem('EmpRoleCode');
    
      let strjson = JSON.stringify(objectData);

      this.httpClient
        .post<MenuInfo[]>(this.baseurl + "UserLogin/CheckPagingAccessRights", strjson, httpOptions)
        .toPromise().then(data => {
          
          if (data.length > 0) {
            // window.location.pathname.split(';')[0]  get pathname without parameter angular
            // window.location.pathname.split('?')[0]  get pathname without parameter query string

            console.log(window.location.pathname.split(';')[0]);
            console.log(window.location.pathname.split('?')[0]);

            console.log(data);

            var accessRights = data.find(o => o.MenuURL == window.location.pathname.split(';')[0] || o.MenuURL == window.location.pathname.split('?')[0]);
              if (!accessRights) {
                localStorage.clear();
                this.login_success.emit(false)
                this.router.navigate(['/']);
                if (confirm("You have no permission to access this page. Please login again")) {
                  setTimeout(function () { location.reload(); }, 1);
                }
              }

            } else {

              localStorage.clear();
              this.login_success.emit(false)
              this.router.navigate(['/']);
              if (confirm("Cannot get user permissions. Please contact admin.")) {
                setTimeout(function () { location.reload(); }, 1);
              }
            }
          
        })
        .catch(err => {

          console.log(err);
          localStorage.clear();
          this.login_success.emit(false);
          this.router.navigate(['/']);
          if (confirm("Something went wrong. Please try again")) {
            //setTimeout(function () { location.reload(); }, 100);
          }
          setTimeout(function () { location.reload(); }, 1);
        });

    //}
  }

}
